import React, { useState,useEffect } from "react";
import Select, { components } from "react-select";
import MultiSelect from '../../../common/MultiSelect';
import {SLIDING_COMMISION,ALLOW_NUMBER,REGEX_DECIMAL_VALIDATION,VEHICLE_USAGE_PASSENGER, VEHICLE_USAGE_COMMERCIAL,VEHICLE_USAGE_LUXURY,ALLOW_YEAR,REGEX_DECIMAL_VALIDATION_4,YEAR_VALIDATION,NET_RATES_ID,STATUS_SUCCESS,INS_TYPE_CTPL,INS_TYPE_COMPREHENSIVE} from '../../../config/constant'

import { useParams } from "react-router-dom";
import {savePartnerConfig,getPartnerConfig,deletePartnerConfig} from '../../../store/slices/partner'
import { useLanguage } from "@src/context/LanguageContext";
import FullPageLoader from '../../../common/FullPageLoader';
import ConfirmPopUp from '../../../common/ConfirmPopUp';
import { toast } from 'react-toastify';


const { ValueContainer, Placeholder } = components;

const CustomValueContainer = ({ children, ...props }: any) => {
  return (
    <ValueContainer {...props}>
      <Placeholder {...props} isFocused={props.isFocused}>
        {props.selectProps.placeholder}
      </Placeholder>
      {React.Children.map(children, (child) =>
        child && child.type !== Placeholder ? child : null
      )}
    </ValueContainer>
  );
};


const VehicleUsageConfig = (props: any) => {
  const {translations} = useLanguage();
  const { id } = useParams();
  const vehicle_usages = props.activeTab === "first" ? VEHICLE_USAGE_PASSENGER : props.activeTab === "second" ? VEHICLE_USAGE_COMMERCIAL : VEHICLE_USAGE_LUXURY
  const [selectedTypes, setSelectedTypes] = useState<any[]>([]);
  const [selectedEngineCapacity, setSelectedEngineCapacity] = useState<any[]>([]);
  const [selectedCommisionRate, setSelectedCommisionRate] = useState<{ value: number; label: string } | null>(null);
  const [showCreatedConfig, setShowCreatedConfig] = useState(false);
  const [isCreateEnable, setIsCreateEnable] = useState(false);
  const [minFmv, setMinFmv] = useState("");
  const [maxFmv, setMaxFmv] = useState("");
  // const [usedVehicleType , setUsedVehicleType] = useState<any[]>([]);
  // const [usedEngineCapacity , setUsedEngineCapacity] = useState<any[]>([]);
  let [loading, setLoading] = useState<boolean>(false)
  const [configRows, setConfigRows] = useState<any[]>([]);
  const [configIndex, setConfigIndex] = useState<any>(null);
  const [configSubIndex, setConfigSubIndex] = useState<any>(null);
  const [config_id_to_delete,setConfigIdToDelete] = useState<any>(null);
  const [config_detail_id_to_delete,setConfigDetailIdToDelete] = useState(null);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [selectedInsuranceType, setSelectedInsuranceType] = useState<{ value: number; label: string } | null>(null);

  const [vehicleType , setVehicleType] = useState<any[]>([]);
  const [engineCapacity , setEngineCapacity] = useState<any[]>([]);
  
  const [errors, setErrors] = useState({
    min_fmv: "",
    max_fmv: "",
    vehicle_type: "",
    engine_capacity: "",
    commission_rate: "",
    insurance_type_id:""
  });

  const [configErrors, setConfigErrors] = useState<any[]>([]);

  const fetchConfigData = async () => {
    setLoading(true);
    try{
      const partnerId = Number(id);
      const payload = {
        "partner_id": isNaN(partnerId) ? null : partnerId,
        "vehicle_usages": vehicle_usages
      }
      const configData:any = await getPartnerConfig(payload)
      if(configData?.status === STATUS_SUCCESS){
        if(Array.isArray(configData.data) && configData.data.length > 0){
          const response = Array.isArray(configData.data) ? configData.data : [];
          // let uniqueVehicleTypes = Array.from(
          //   new Set(response.flatMap((row: any) => row.selectedTypes || []))
          // );
          // const uniqueEngineTypes = Array.from(
          //   new Set(response.flatMap((row: any) => row.selectedEngineCapacity || []))
          // );
          
          // if (Array.isArray(uniqueEngineTypes) && Array.isArray(props.engineCapacity) && props.engineCapacity.length > 0){
          //   const engineValues = props.engineCapacity.map((ec:any) => ec.value);
          //   const hasAllEngineTypes = engineValues.every((val:any) => uniqueEngineTypes.includes(val));
          //   if (!hasAllEngineTypes) {
          //     uniqueVehicleTypes = uniqueVehicleTypes.filter((id: any) => id !== props.motorCycleId);
          //   }
          // }
          // setUsedVehicleType(uniqueVehicleTypes);
          // setUsedEngineCapacity(uniqueEngineTypes);
          // setUsedVehicleType([]);
          // setUsedEngineCapacity([]);
          const updatedConfigRows = response.map((row: any) => ({
            id: row.id ?? null,
            insurance_type_id:row.insurance_type_id ?? null,
            selectedTypes: row.selectedTypes || [],
            selectedEngineCapacity: row.selectedEngineCapacity || [],
            selectedCommisionRate: row.selectedCommisionRate ?? null,
            minFmv: row.minFmv ?? "",
            maxFmv: row.maxFmv ?? "",
            bipd : row?.bipd === "" || row?.bipd === undefined || row?.bipd === null ? "" : row?.bipd,
            baseIssueRows: (row.baseIssueRows || []).map((baseRow: any) => ({
              id:baseRow.id || null,
              makeYearFrom: baseRow.makeYearFrom || "",
              makeYearTo: baseRow.makeYearTo || "",
              baseIssuefrom: baseRow.baseIssuefrom || "",
              baseIssueto: baseRow.baseIssueto || "",
              withAON: baseRow.withAON || "",
              withoutAON: baseRow.withoutAON || "",
              isYearShow: baseRow.isYearShow ?? true,
            })),
          }));
          if(vehicle_usages === VEHICLE_USAGE_LUXURY && configData.data.length > 0){
            setIsCreateEnable(true);
          }
          setConfigRows(updatedConfigRows);
          setShowCreatedConfig(true);
        }else{
          setConfigRows([]);
          setShowCreatedConfig(false);
          setIsCreateEnable(false);
        }
      }else{
        setShowCreatedConfig(false);
      }
    }catch (error) {
      console.error("Error fetching config data:", error);
      setShowCreatedConfig(false);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    if (props.commisionRate.length > 0) {
      // Clear state on tab change
      setIsCreateEnable(false);
      // setUsedVehicleType([]);
      // setUsedEngineCapacity([]);
      setSelectedTypes([]);
      setSelectedEngineCapacity([]);
      setSelectedCommisionRate(null);
      setSelectedInsuranceType(null);
      setConfigErrors([]);
      setMinFmv("");
      setMaxFmv("");
      fetchConfigData()
    }
    // eslint-disable-next-line
  }, [props.activeTab,props.commisionRate]);

  const handleChange = (selected: any, key: string) => {
    setErrors((prev) => ({ ...prev, [key]: "" }));
    switch (key) {
    case "vehicle_type":
      setSelectedTypes(selected?.map((item: any) => item.value) || []);
      break;
    case "engine_capacity":
      setSelectedEngineCapacity(selected?.map((item: any) => item.value) || []);
      break;
    case "commission_rate":
      setSelectedCommisionRate(selected);
      break;
    case "min_fmv":
      if (ALLOW_NUMBER.test(selected) && (REGEX_DECIMAL_VALIDATION.test(selected) || REGEX_DECIMAL_VALIDATION_4.test(selected))) {
        setMinFmv(selected);
      }
      break;
    case "max_fmv":
       if (ALLOW_NUMBER.test(selected) && (REGEX_DECIMAL_VALIDATION.test(selected) || REGEX_DECIMAL_VALIDATION_4.test(selected))) {
        setMaxFmv(selected);
      }
      break;
    case "insurance_type_id":
      setSelectedInsuranceType(selected);
      if (selected.value === INS_TYPE_CTPL) {
        setErrors((prev) => ({ ...prev, commission_rate: "" }));
        const sliding = props.commisionRate.find((c: any) => c.value === SLIDING_COMMISION);
        setSelectedCommisionRate(sliding);
      }else{
        setSelectedCommisionRate(null);
      }
      const rows = configRows.filter((r: any) => r.insurance_type_id === selected.value);
      const usedTypes = Array.from(new Set(rows.flatMap((r: any) => r.selectedTypes || [])));
      const usedEngine = Array.from(new Set(rows.flatMap((r: any) => r.selectedEngineCapacity || [])));
      let finalUsedTypes = [...usedTypes];
      const allEngineValues = props.engineCapacity.map((ec: any) => ec.value);
      const hasAllEngineTypes = allEngineValues.every((val: any) => usedEngine.includes(val));
      if (!hasAllEngineTypes) {
        finalUsedTypes = finalUsedTypes.filter((id: any) => id !== props.motorCycleId);
      }
      setVehicleType(props.vehicleTypes.filter((v: any) => !finalUsedTypes.includes(v.value)));
      setEngineCapacity(props.engineCapacity.filter((e: any) => !usedEngine.includes(e.value)));
        if (vehicle_usages === VEHICLE_USAGE_LUXURY) {          
          const typeComp = configRows.some(row => row.insurance_type_id === INS_TYPE_COMPREHENSIVE);
          const typeCTPL = configRows.some(row => row.insurance_type_id === INS_TYPE_CTPL);
                    
          if ((typeComp && selected.value === INS_TYPE_COMPREHENSIVE) || (typeCTPL && selected.value === INS_TYPE_CTPL)) {
            setIsCreateEnable(true);
          } else {
            setIsCreateEnable(false);
          }
        }
      break;
    default:
      break;
    }
  };


  const validateSelectedConfig = () => {
    const newErrors: any = {
      min_fmv: "",
      max_fmv: "",
      vehicle_type: "",
      engine_capacity: "",
      commission_rate: "",
      insurance_type_id:""
    };

    let hasError = false;

    if (props.activeTab === "third") {
      const min = Number(minFmv);
      const max = Number(maxFmv);

      if (!minFmv.trim()) {
        newErrors.min_fmv = "MIN FMV is required.";
        hasError = true;
      }

      if (!maxFmv.trim()) {
        newErrors.max_fmv = "MAX FMV is required.";
        hasError = true;
      }

      if (!isNaN(min) && !isNaN(max) && minFmv.trim() && maxFmv.trim() && min >= max) {
        newErrors.min_fmv = "MIN FMV must be less than MAX FMV.";
        hasError = true;
      }
    }

    if (["first", "second"].includes(props.activeTab)) {
      if (!selectedTypes.length) {
        newErrors.vehicle_type = "Vehicle Type is required.";
        hasError = true;
      }
    }

    if (selectedTypes.includes(props.motorCycleId) && props.activeTab !== "third") {
      if (!selectedEngineCapacity.length) {
        newErrors.engine_capacity = "Engine Capacity is required.";
        hasError = true;
      }
    }

    if (!selectedCommisionRate) {
      newErrors.commission_rate = "Commission Rate is required.";
      hasError = true;
    }

    if (!selectedInsuranceType) {
      newErrors.insurance_type_id = "Insurance Type is required.";
      hasError = true;
    }

    setErrors(newErrors);

    return hasError;
  };

  

  const createSelectedConfig = () => {
    const validateFilter = validateSelectedConfig();
    if (validateFilter) return;
    setLoading(true);
    try{
      const newConfig = {
        id: null,
        insurance_type_id:selectedInsuranceType?.value ?? null,
        selectedTypes,
        selectedEngineCapacity,
        selectedCommisionRate: selectedCommisionRate?.value ?? null,
        minFmv,
        maxFmv,
        baseIssueRows: [
          {
            id:null,
            makeYearFrom: "",
            makeYearTo: "",
            baseIssuefrom: "",
            baseIssueto: "",
            withAON: "",
            withoutAON: "",
            isYearShow:true
          },
        ],
      };

      if (isDuplicateConfig(configRows, newConfig)) {
        toast.error(translations.Insurance?.['Duplicate configuration']);   
        return;
      }

      
      setConfigRows(prev => {
        const updated = [...prev, newConfig];
        if (updated.length === 1) {
          setConfigErrors([]);
        }
        
        // const allUniqueEngineCapacities = Array.from(
        //   new Set(updated.flatMap(row => row.selectedEngineCapacity || []))
        // );

        // let uniqueVehicleTypes = [...selectedTypes];
        // const engineValues = props.engineCapacity.map((ec: any) => ec.value);
        // const hasAllEngineTypes = engineValues.every((val: any) => allUniqueEngineCapacities.includes(val));

        // if (!hasAllEngineTypes) {
        //   uniqueVehicleTypes = selectedTypes.filter(
        //     (id: any) => id !== props.motorCycleId
        //   );
        // }

        // setUsedVehicleType(prev => [...prev, ...uniqueVehicleTypes]);
        // setUsedEngineCapacity(prev => [...prev, ...selectedEngineCapacity]);

        return updated; // must return updated array
      });
      if(configRows.length === 0){
        setConfigErrors([]);
      }
      setVehicleType([]);
      setEngineCapacity([]);
      setSelectedTypes([]);
      setSelectedEngineCapacity([]);
      setSelectedCommisionRate(null);
      setSelectedInsuranceType(null);
      setMinFmv("");
      setMaxFmv("");
      setShowCreatedConfig(true);
    }catch (error) {
      console.error("Error while creating:", error);
    } finally {
      setLoading(false);
    }
  }

  const handleAddRow = (index:number) => {
    const updated = [...configRows];
    const updatedErrors = [...configErrors];
    updated[index].baseIssueRows.push({id:null,makeYearFrom: "", makeYearTo: "", baseIssuefrom: "", baseIssueto: "",withAON: '', withoutAON: '',isYearShow:true });
    if (!updatedErrors[index]) {
      updatedErrors[index] = { baseIssueRows: [] };
    }
    updatedErrors[index].baseIssueRows[updated[index].baseIssueRows.length - 1] = {
      makeYearFrom: "",
      makeYearTo: "",
      withAON: "",
      withoutAON: "",
      baseIssuefrom: "",
      baseIssueto: "",
    };
    setConfigRows(updated);
    setConfigErrors(updatedErrors);
  };

  const handleBaseIssueAddRow = (rowIndex: number) => {
    const updated = [...configRows];
    const updatedErrors = [...configErrors];
    const currentBaseIssueRows = updated[rowIndex].baseIssueRows;
     const lastValidYearRow = [...currentBaseIssueRows].reverse().find(row => row.makeYearFrom && row.makeYearTo);
    updated[rowIndex].baseIssueRows.push({id:null,makeYearFrom: lastValidYearRow?.makeYearFrom ?? null, makeYearTo: lastValidYearRow?.makeYearTo ?? null, baseIssuefrom: "", baseIssueto: "",withAON: '', withoutAON: '',isYearShow:false });
    if (!updatedErrors[rowIndex]) {
      updatedErrors[rowIndex] = { baseIssueRows: [] };
    }
    const newErrorIndex = updated[rowIndex].baseIssueRows.length - 1;
    updatedErrors[rowIndex].baseIssueRows[newErrorIndex] = {
      makeYearFrom: "",
      makeYearTo: "",
      withAON: "",
      withoutAON: "",
      baseIssuefrom: "",
      baseIssueto: "",
    };
    // updatedErrors[rowIndex].baseIssueRows[updated[rowIndex].baseIssueRows.length - 1]
    setConfigRows(updated);
    setConfigErrors(updatedErrors);
  };


  function validateConfigRows(configBlocks: any[]) {
    const validationErrors: any[] = [];
    let currentGroup: any[] = [];
    let lastYearShowIndex = -1;
    
    for (let blockIndex = 0; blockIndex < configBlocks.length; blockIndex++) {
      const block = configBlocks[blockIndex];
      const isCTPL = Number(block.insurance_type_id) === INS_TYPE_CTPL;
      const blockErrors: any = {
        baseIssueRows: [],
      };

      const baseIssueRows = block.baseIssueRows || [];

      // Initialize all error rows
      for (let i = 0; i < baseIssueRows.length; i++) {
        blockErrors.baseIssueRows[i] = {};
      }

      // validate bipd
      if (NET_RATES_ID.includes(block.selectedCommisionRate)) {
        const bipdValue = block.bipd !== null && block.bipd !== undefined ? String(block.bipd).trim() : "";
        if (bipdValue === "") {
          blockErrors.bipd = "BI/PD (%) is required.";
        } else if (isNaN(Number(bipdValue))) {
          blockErrors.bipd = "BI/PD (%) must be a number.";
        } else if (Number(bipdValue) < 0 || Number(bipdValue) > 100) {
          blockErrors.bipd = "BI/PD (%) must be greater than and equal to 0 and less than or equal to 100.";
        }
      }

      // Make Year Validation (only for isYearShow === true rows)
      const makeYearGroups = baseIssueRows.filter((row: any) => row.isYearShow);
      for (let groupIndex = 0; groupIndex < makeYearGroups.length; groupIndex++) {
        const group = makeYearGroups[groupIndex];
        const subIndex = baseIssueRows.findIndex((r: any) => r === group);
        const from = Number(group.makeYearFrom);
        const to = Number(group.makeYearTo);
        const yearErrors: any = {};

        if (!group.makeYearFrom) {
          yearErrors.makeYearFrom = "Min year is required.";
        } else if (isNaN(from)) {
          yearErrors.makeYearFrom = "Min year must be a number.";
        }else if (!YEAR_VALIDATION.test(group.makeYearFrom)) {
          yearErrors.makeYearFrom = "Enter a valid 4-digit year.";
        }

        if (!group.makeYearTo) {
          yearErrors.makeYearTo = "Max year is required.";
        } else if (isNaN(to)) {
          yearErrors.makeYearTo = "Max year must be a number.";
        }else if (!YEAR_VALIDATION.test(group.makeYearTo)) {
          yearErrors.makeYearTo = "Enter a valid 4-digit year.";
        }

        if (!yearErrors.makeYearFrom && !yearErrors.makeYearTo) {
          // Allow equal values
          if (to < from) {
            yearErrors.makeYearTo = "Max year should be greater than or equal to Min year.";
          }

          if (groupIndex > 0) {
            const prevTo = Number(makeYearGroups[groupIndex - 1].makeYearFrom);
            if (!isNaN(prevTo) && to >= prevTo) {
              yearErrors.makeYearTo = `Max year should be less than previous row's Min year (${prevTo}).`;
            }
          }
        }

        // Merge yearErrors into the correct row
        Object.assign(blockErrors.baseIssueRows[subIndex], yearErrors);
      }

      // Per row validation
      for (let rowIndex = 0; rowIndex < baseIssueRows.length; rowIndex++) {
        const row = baseIssueRows[rowIndex];
        const rowErrors = blockErrors.baseIssueRows[rowIndex];
        if (row.isYearShow) {
          currentGroup = [rowIndex];
          lastYearShowIndex = rowIndex;
        } else {
          currentGroup.push(rowIndex);
        }

        // Commission Rate (with AON) must be > 0
        if (!isCTPL) {
          if (!row.withAON && row.withAON !== 0) {
            rowErrors.withAON = "Commission Rate (with AON) is required.";
          }else if (isNaN(Number(row.withAON)) || Number(row.withAON) <= 0) {
            rowErrors.withAON = "Commission Rate (with AON) must be greater than 0.";
          }
        }
        // Commission Rate (without AON) must be > 0
        if (!row.withoutAON && row.withoutAON !== 0) {
          rowErrors.withoutAON = "Commission Rate (without AON) is required.";
        }else if (isNaN(Number(row.withoutAON)) || Number(row.withoutAON) <= 0) {
          rowErrors.withoutAON = "Commission Rate (without AON) must be greater than 0.";
        }

        if (!isCTPL && block.selectedCommisionRate === SLIDING_COMMISION) {
          const min = Number(row.baseIssuefrom);
          const max = Number(row.baseIssueto);

          if (!row.baseIssueto) {
            rowErrors.baseIssueto = "Max Rate is required.";
          } else if (isNaN(max)) {
            rowErrors.baseIssueto = "Max Rate must be a number.";
          }

          if (!row.baseIssuefrom) {
            rowErrors.baseIssuefrom = "Min Rate is required.";
          } else if (isNaN(min)) {
            rowErrors.baseIssuefrom = "Min Rate must be a number.";
          }
         
          if (!rowErrors.baseIssuefrom && !rowErrors.baseIssueto) {
            if (min > max) {
              rowErrors.baseIssuefrom = "Min Rate should be less than or equal to Max Rate.";
              rowErrors.baseIssueto = "Max Rate should be greater than or equal to Min Rate.";
            }
            const groupPos = currentGroup.indexOf(rowIndex);
            if (groupPos > 0) {
              const prevIndex = currentGroup[groupPos - 1];
              // const prevMax = Number(baseIssueRows[prevIndex].baseIssueto);
              const prevMin = Number(baseIssueRows[prevIndex].baseIssuefrom);
              // if (!isNaN(prevMax) && min <= prevMax) {
              //   rowErrors.baseIssuefrom = `Min Rate (${min}) must be greater than previous Max (${prevMax}).`;
              // }
              if (!isNaN(prevMin) && max >= prevMin) {
                rowErrors.baseIssueto = `Max Rate (${max}) must be less than previous Min (${prevMin}).`;
              }
            }
          }
        }
      }

      validationErrors.push(blockErrors);
    }

    setConfigErrors(validationErrors);

    const hasErrors = validationErrors.some(blockError =>
      Object.keys(blockError).some(key =>
        (key !== 'baseIssueRows' && blockError[key]) ||
        (key === 'baseIssueRows' && blockError.baseIssueRows.some((rowErr: any) => Object.keys(rowErr).length > 0))
      )
    );

    return !hasErrors;
  }


  const handleSave = async () => {
    const isValid = validateConfigRows(configRows);
    if (!isValid) {
      return;
    }
    setLoading(true);
    try{
      const partner_id = Number(id);
      let modifiedData: any[] = [];
      if (configRows.length === 0) {
        modifiedData = [
          {
            id: Date.now(),
            partner_id,
            vehicle_usages
          }
        ];
      }else{
        modifiedData = configRows.map(row => {
          return {
            ...row,
            partner_id,
            vehicle_usages,
            bipd: row?.bipd === "" || row?.bipd === undefined || row?.bipd === null ? "" : String(row?.bipd)
          };
        });
      }
      const configData:any = await savePartnerConfig({config:modifiedData , is_all_delete:configRows.length === 0})
      if(configData.status === STATUS_SUCCESS){
        fetchConfigData();
      }else{
        setShowCreatedConfig(true);
      }
    }catch (error) {
      console.error("Error while saving:", error);
    } finally {
      setLoading(false);
    }
  }

  const handleCancel = async () => {
    fetchConfigData();
  }

  const confirmYes = async () => {
    setLoading(true);
    try{
       let deletePayload:any = {
         config_detail_id : config_detail_id_to_delete
       }
       if(config_id_to_delete){
         deletePayload['config_id'] = config_id_to_delete
       }
       const deleteConfig:any = await deletePartnerConfig(deletePayload)
       if(deleteConfig.status === STATUS_SUCCESS){
         setConfigRows(prevRows => {
           const updated = [...prevRows];
           // Parent removal case
           if (updated[configIndex].baseIssueRows.length === 1) {
            const removedTypes = updated[configIndex].selectedTypes;
            const removedEngineCapacity = updated[configIndex].selectedEngineCapacity;
            updated.splice(configIndex, 1);
            setSelectedInsuranceType(null);
            setVehicleType([]);
            setEngineCapacity([]);
            // setUsedVehicleType(prev =>
            //   prev.filter(value => !removedTypes.includes(value))
            // );
            // setUsedEngineCapacity(prev =>
            //   prev.filter(value => !removedEngineCapacity.includes(value))
            // );
           }
           // Child removal case
           else {
             updated[configIndex].baseIssueRows.splice(configSubIndex, 1);
           }
           return updated;
         });
        //  fetchConfigData();
       }
       confirmNo();
     }catch (error) {
      console.error("Error while deleting:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (vehicle_usages === VEHICLE_USAGE_LUXURY) {
      
      const hasType1 = configRows.some(row => row.insurance_type_id === INS_TYPE_COMPREHENSIVE);
      const hasType2 = configRows.some(row => row.insurance_type_id === INS_TYPE_CTPL);
      // Disable only when BOTH present
      if (hasType1 && hasType2) {
        setIsCreateEnable(true); 
      } else {
        setIsCreateEnable(false); 
      }
    }
  }, [configRows, vehicle_usages]);

  const confirmNo = () => {
      setConfigIndex(null);
      setConfigSubIndex(null);
      setConfigIdToDelete(null);
      setConfigDetailIdToDelete(null);
      setShowConfirmation(false);
  };

  const handleDeleteConfigRow = (index:number, subIndex:number) => {
    const updated = [...configRows];
    if (updated[index].baseIssueRows.length === 1) {
      if(updated[index]?.id != null){
        setConfigIndex(index);
        setConfigSubIndex(subIndex);
        setConfigIdToDelete(updated[index]?.id);
        setConfigDetailIdToDelete(updated[index].baseIssueRows[subIndex]?.id);
        setShowConfirmation(true);
      }else{
        const removedTypes = updated[index].selectedTypes;
        const removedEngineCapacity = updated[index].selectedEngineCapacity;
        setSelectedInsuranceType(null);
        setVehicleType([]);
        setEngineCapacity([]);
        updated.splice(index, 1);
        // setUsedVehicleType(prev =>
        //   prev.filter(value => !removedTypes.includes(value))
        // );
        // setUsedEngineCapacity(prev =>
        //   prev.filter(value => !removedEngineCapacity.includes(value))
        // );
      }
    } else {
      if(updated[index].baseIssueRows[subIndex]?.id != null){
        setConfigIndex(index);
        setConfigSubIndex(subIndex);
        setConfigDetailIdToDelete(updated[index].baseIssueRows[subIndex]?.id);
        setShowConfirmation(true);
      }else{
        updated[index].baseIssueRows.splice(subIndex, 1);
      }
    }
    setConfigRows(updated);
  };

  const isDuplicateConfig = (rows: any[], newConfig: any) => {
    return rows.some(row =>
      row.insurance_type_id === newConfig.insurance_type_id &&
      JSON.stringify(row.selectedTypes) === JSON.stringify(newConfig.selectedTypes) &&
      JSON.stringify(row.selectedEngineCapacity) === JSON.stringify(newConfig.selectedEngineCapacity) &&
      row.selectedCommisionRate === newConfig.selectedCommisionRate &&
      row.minFmv === newConfig.minFmv &&
      row.maxFmv === newConfig.maxFmv
    );
  };
  
  return (
    <>
      <FullPageLoader show={loading} />
      {showConfirmation === false ? ("") : (
          <ConfirmPopUp
              confirmNo={confirmNo}
              confirmYes={confirmYes}
              message={translations.Insurance?.['Delete_Config'] || translations.commonMsg?.loading}
          />
      )}
      <div className="basic-premium-outer">
        <div className="basic-premium-filter">
          <fieldset className="single-select">
            <div className="material">
              <Select
                components={{ ValueContainer: CustomValueContainer }}
                options={props.insuranceType}
                onChange={(e: any) => handleChange(e, 'insurance_type_id')}
                value={selectedInsuranceType}
                placeholder="Insurance Type"
                className="react-select"
                classNamePrefix="react-select"
              />
              {errors.insurance_type_id && <div className="error-txt">{errors.insurance_type_id}</div>}
            </div>
          </fieldset>
          {
            props.activeTab === "third" &&
            <>
                <fieldset className="single-select">
                  <div className="material">
                    <input id="min_fmv" type="text" name="" className="form-input" placeholder="MIN FMV" value={minFmv} onChange={(e) => handleChange(e.target.value, "min_fmv")}/>
                    {errors.min_fmv && <div className="error-txt">{errors.min_fmv}</div>}
                  </div>
                </fieldset>
                <fieldset className="single-select">
                  <div className="material">
                    <input id="max_fmv" type="text" name="" className="form-input" placeholder="MAX FMV" value={maxFmv} onChange={(e) => handleChange(e.target.value, "max_fmv")}/>
                    {errors.max_fmv && <div className="error-txt">{errors.max_fmv}</div>}
                  </div>
                </fieldset>
              </>
          }
          {
            ["first", "second"].includes(props.activeTab) && 
            <fieldset className="multiselect-dropDown config-multiselect">
              <div className={(selectedTypes && selectedTypes.length) ? "active-label material animation-effect" : "material animation-effect "}>
                <MultiSelect
                    // options={vehicleType.filter((v: any) => !usedVehicleType.includes(v.value))}
                    options={vehicleType}
                    isSelectAll={true}
                    value={props.vehicleTypes.filter((v:any) => selectedTypes.includes(v.value))}
                    onChange={(e: any) => handleChange(e, 'vehicle_type')}
                    placeholder={""}
                    isClearable={false}
                />
                <label data-label="Vehicle Type" className="form-label"></label>
                {errors.vehicle_type && <div className="error-txt">{errors.vehicle_type}</div>}
              </div>
            </fieldset>
          }
          {
            selectedTypes.includes(props.motorCycleId) && props.activeTab !== "third" &&
            <fieldset className="multiselect-dropDown config-multiselect">
              <div className={(selectedEngineCapacity && selectedEngineCapacity.length) ? "active-label material animation-effect" : "material animation-effect "}>
                <MultiSelect
                    // options={props.engineCapacity.filter((v: any) => !usedEngineCapacity.includes(v.value))}
                    options={engineCapacity}
                    isSelectAll={true}
                    value={props.engineCapacity.filter((v:any) => selectedEngineCapacity.includes(v.value))}
                    onChange={(e: any) => handleChange(e, 'engine_capacity')}
                    placeholder={""}
                    isClearable={false}
                />
                <label data-label="Engine Capacity" className="form-label"></label>
                {errors.engine_capacity && <div className="error-txt">{errors.engine_capacity}</div>}
              </div>
            </fieldset>
          }
          <fieldset className="single-select">
            <div className="material">
              <Select
                components={{ ValueContainer: CustomValueContainer }}
                options={
                  selectedInsuranceType?.value === INS_TYPE_CTPL
                    ? props.commisionRate.filter((c: any) => c.value === SLIDING_COMMISION)
                    : props.commisionRate
                }
                onChange={(e: any) => handleChange(e, 'commission_rate')}
                value={selectedCommisionRate}
                placeholder="Commision Rate"
                className="react-select"
                classNamePrefix="react-select"
              />
              {errors.commission_rate && <div className="error-txt">{errors.commission_rate}</div>}
            </div>
          </fieldset>
          <div className="btn-submit-reset">
            <button className="btn-primary" onClick={createSelectedConfig} disabled={isCreateEnable}>Create</button>
          </div>
        </div>
        
        { 
          showCreatedConfig && (
             <>
                {configRows.map((row, index) => (
                  <div className={`config-vechile-type-table data-table m-lg-b p-md-b ${row.baseIssueRows.length === 1 && row.selectedCommisionRate  && NET_RATES_ID.includes(+row.selectedCommisionRate) ? "table-padding-b" : ""}`}>
                    <table key={`table-${index}`}>
                      <thead>
                        <tr>
                          <th>Insurance Type</th>
                          {
                            ["first", "second"].includes(props.activeTab) ? 
                            <th>Vehicle Type</th> : 
                            (
                              <>
                                <th>Min FMV</th>
                                <th>Max FMV</th>
                              </>
                            )
                          }
                          {
                            row.selectedTypes.includes(props.motorCycleId) && props.activeTab !== "third" && <th>Engine Capacity</th>
                          }
                          <th>Commision Rate</th>
                          <th>Make Year</th>
                          {
                            row.selectedCommisionRate && +row.selectedCommisionRate === SLIDING_COMMISION &&
                            <th className="th-whitespace">Base Issue Rate (Max to Min)</th>
                          }
                          <th className="th-whitespace comm-header">Commission Rate (With AON) (%)</th>
                          <th className="th-whitespace comm-header">Commission Rate (Without AON) (%)</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                          {row.baseIssueRows.map((item:any, subIndex:number) => (
                            <tr key={`row-${index}-sub-${subIndex}`}>
                              {
                                subIndex === 0 ? (
                                    <>
                                      <td>
                                        <fieldset className="single-select">
                                          <div className="material">
                                            <Select
                                              components={{ ValueContainer: CustomValueContainer }}
                                              options={props.insuranceType}
                                              onChange={(e: any) => handleChange(e, 'insurance_type_id')}
                                              value={props.insuranceType.find((v: any) => v.value === row.insurance_type_id) || null}
                                              placeholder="Insurance Type"
                                              className="react-select"
                                              classNamePrefix="react-select"
                                              isDisabled={true}
                                            />
                                          </div>
                                        </fieldset>
                                      </td>
                                      {
                                        ["first", "second"].includes(props.activeTab) ? (
                                          <td>
                                            <fieldset className="multiselect-dropDown">
                                              <div className={(row.selectedTypes && row.selectedTypes.length) ? "active-label material animation-effect" : "material animation-effect "}>
                                                <MultiSelect
                                                    options={props.vehicleTypes}
                                                    isSelectAll={true}
                                                    value={props.vehicleTypes.filter((v:any) => row.selectedTypes.includes(v.value))}
                                                    onChange={(e: any) => handleChange(e, 'vehicle_type')}
                                                    placeholder={""}
                                                    isClearable={false}
                                                    isDisabled={true}
                                                />
                                                <label data-label="Vehicle Type" className="form-label"></label>
                                                {
                                                  row.selectedTypes && row.selectedTypes.length > 0 &&
                                                  <p className="text-black p-absolute">
                                                    {props.vehicleTypes.filter((v: any) => row.selectedTypes.includes(v.value)).map((v: any) => v.label).join(', ')}
                                                  </p>
                                                }
                                              </div>
                                            </fieldset>
                                          </td>
                                        ) : (
                                          <>
                                            <td>
                                              <fieldset className="single-select">
                                                <div className="material">
                                                  <input type="text" className="form-input" placeholder="MIN FMV" value={row.minFmv} onChange={(e) => handleChange(e.target.value, "min_fmv")} readOnly/>
                                                </div>
                                              </fieldset>
                                            </td>
                                            <td>
                                              <fieldset className="single-select">
                                                <div className="material">
                                                  <input type="text" className="form-input" placeholder="MAX FMV" value={row.maxFmv} onChange={(e) => handleChange(e.target.value, "max_fmv")} readOnly/>
                                                </div>
                                              </fieldset>
                                            </td>
                                          </>
                                        )
                                      }

                                        {
                                          row.selectedTypes.includes(props.motorCycleId) && props.activeTab !== "third" &&
                                          <td>
                                            <fieldset className="multiselect-dropDown">
                                              <div className={(row.selectedEngineCapacity && row.selectedEngineCapacity.length) ? "active-label material animation-effect" : "material animation-effect "}>
                                                <MultiSelect
                                                    options={props.engineCapacity}
                                                    isSelectAll={true}
                                                    value={props.engineCapacity.filter((v:any) => row.selectedEngineCapacity.includes(v.value))}
                                                    onChange={(e: any) => handleChange(e, 'engine_capacity')}
                                                    placeholder={""}
                                                    isClearable={false}
                                                    isDisabled={true}
                                                />
                                                <label data-label="Engine Capacity" className="form-label"></label>
                                                {
                                                  row.selectedEngineCapacity && row.selectedEngineCapacity.length > 0 &&
                                                  <p className="text-black p-absolute">
                                                    {props.engineCapacity.filter((v: any) => row.selectedEngineCapacity.includes(v.value)).map((v: any) => v.label).join(', ')}
                                                  </p>
                                                }
                                              </div>
                                            </fieldset>
                                          </td>
                                        }

                                      <td>
                                        <fieldset className="single-select">
                                          <div className="material">
                                            <Select
                                              components={{ ValueContainer: CustomValueContainer }}
                                              options={props.commisionRate}
                                              onChange={(e: any) => handleChange(e, 'commission_rate')}
                                              value={props.commisionRate.find((v: any) => v.value === row.selectedCommisionRate) || null}
                                              placeholder="Commision Rate"
                                              className="react-select"
                                              classNamePrefix="react-select"
                                              isDisabled={true}
                                            />
                                            {
                                              row.selectedCommisionRate && NET_RATES_ID.includes(+row.selectedCommisionRate) &&
                                                <fieldset className="form-filed p-absolute bipd_input">
                                                  <div className="material">
                                                      <input id="bipd_id" type="text" placeholder=" " className="form-input" value={row?.bipd !== "" && row?.bipd !== undefined && row?.bipd !== null ? row.bipd : ""} title={row.bipd ? `${row.bipd}%` : "BI/PD (%)"} onChange={(e) => {
                                                    const selectedValue = e.target.value;
                                                      if (selectedValue === '' || ((REGEX_DECIMAL_VALIDATION.test(selectedValue) || REGEX_DECIMAL_VALIDATION_4.test(selectedValue)) && parseFloat(selectedValue) <= 100)) {
                                                        const updated = [...configRows];
                                                        updated[index].bipd = selectedValue;
                                                        setConfigRows(updated);
                                                      }
                                                    }}/>
                                                      <label data-label="BI/PD (%)*" className="form-label"></label>
                                                      {configErrors[index]?.bipd && (
                                                        <span className="error-msg">{configErrors[index].bipd}</span>
                                                      )}
                                                  </div>
                                                </fieldset>
                                            }
                                          </div>
                                        </fieldset>
                                      </td>
                                    </>
                                  ) : (
                                    <>
                                      <td></td>
                                      {
                                        ["first", "second"].includes(props.activeTab) ? (
                                          <td></td>
                                        ) : (
                                          <>
                                            <td></td>
                                            <td></td>
                                          </>
                                        )
                                      }

                                        {
                                          row.selectedTypes.includes(props.motorCycleId) && props.activeTab !== "third" &&
                                          <td></td>
                                        }

                                      <td></td>
                                    </>
                                  )
                                }
                              <td>
                                  {
                                    item.isYearShow && (
                                      <div className="years-iput-year">
                                        <fieldset>
                                          <div className="material">
                                            <input type="text" className="form-input" placeholder="Max Year" value={item.makeYearTo} title={item.makeYearTo || "Max Year"} onChange={(e) => {
                                              if (ALLOW_YEAR.test(e.target.value)) {
                                                const updated = [...configRows];
                                                updated[index].baseIssueRows[subIndex].makeYearTo = e.target.value;
                                                setConfigRows(updated);
                                              }
                                            }}/>
                                            {configErrors[index]?.baseIssueRows?.[subIndex]?.makeYearTo && <p className="error-msg">{configErrors[index].baseIssueRows[subIndex].makeYearTo}</p>}
                                          </div>
                                        </fieldset>
                                        <span>to</span>
                                        <fieldset>
                                          <div className="material">
                                            <input type="text" className="form-input" placeholder="Min Year" value={item.makeYearFrom} title={item.makeYearFrom || "Min Year"} onChange={(e) => {
                                              if (ALLOW_YEAR.test(e.target.value)) {
                                                const updated = [...configRows];
                                                updated[index].baseIssueRows[subIndex].makeYearFrom = e.target.value;
                                                setConfigRows(updated);
                                              }
                                            }}/>
                                            {configErrors[index]?.baseIssueRows?.[subIndex]?.makeYearFrom && <p className="error-msg">{configErrors[index].baseIssueRows[subIndex].makeYearFrom}</p>}
                                          </div>
                                        </fieldset>
                                      </div>
                                    )
                                  }
                                  {item.isYearShow && subIndex === configRows[index].baseIssueRows.map((r:any, i:number) => (r.isYearShow ? i : -1)).filter((i:number) => i !== -1).pop() && (
                                      <a href="#!" onClick={(e) => { e.preventDefault(); handleAddRow(index); }} className="p-absolute">
                                        <i className="ic-add"></i>Add Row
                                      </a>
                                  )}
                              </td>

                              {
                                row.selectedCommisionRate && +row.selectedCommisionRate === SLIDING_COMMISION && (
                                  <td>
                                      <div className="years-iput-ph" key={`base-${row.id}-${subIndex}`}>
                                        <fieldset>
                                          <div className="material">
                                            <input
                                              type="text"
                                              className="form-input"
                                              placeholder="Max Rate"
                                              value={item.baseIssueto}
                                              title={item.baseIssueto || "Max Rate"}
                                              onChange={(e) => {
                                                const selectedValue = e.target.value;
                                                if (selectedValue === '' ||
                                                  ((REGEX_DECIMAL_VALIDATION.test(selectedValue) || REGEX_DECIMAL_VALIDATION_4.test(selectedValue)) && parseFloat(selectedValue) <= 100)) {
                                                  const updated = [...configRows];
                                                  updated[index].baseIssueRows[subIndex].baseIssueto = selectedValue;
                                                  setConfigRows(updated);
                                                }
                                              }}
                                              disabled={Number(row.insurance_type_id) === INS_TYPE_CTPL}
                                            />
                                            {configErrors[index]?.baseIssueRows?.[subIndex]?.baseIssueto && (
                                              <div className="error-msg">{configErrors[index].baseIssueRows[subIndex].baseIssueto}</div>
                                            )}
                                          </div>
                                        </fieldset>
                                        <span>to</span>
                                        <fieldset>
                                          <div className="material">
                                            <input
                                              type="text"
                                              className="form-input"
                                              placeholder="Min Rate"
                                              value={item.baseIssuefrom}
                                              title={item.baseIssuefrom || "Min Rate"}
                                              onChange={(e) => {
                                                const selectedValue = e.target.value;
                                                if (selectedValue === '' ||
                                                  ((REGEX_DECIMAL_VALIDATION.test(selectedValue) || REGEX_DECIMAL_VALIDATION_4.test(selectedValue)) && parseFloat(selectedValue) <= 100)) {
                                                  const updated = [...configRows];
                                                  updated[index].baseIssueRows[subIndex].baseIssuefrom = selectedValue;
                                                  setConfigRows(updated);
                                                }
                                              }}
                                              disabled={Number(row.insurance_type_id) === INS_TYPE_CTPL}
                                            />
                                            {configErrors[index]?.baseIssueRows?.[subIndex]?.baseIssuefrom && (
                                              <div className="error-msg">{configErrors[index].baseIssueRows[subIndex].baseIssuefrom}</div>
                                            )}
                                          </div>
                                        </fieldset>
                                      </div>
                                    {subIndex === row.baseIssueRows.length - 1 && Number(row.insurance_type_id) !== INS_TYPE_CTPL && (
                                      <div className="add-more-btn">
                                        <a href="#!" onClick={(e) => { e.preventDefault(); handleBaseIssueAddRow(index); }}>
                                          <i className="ic-add"></i> Add Row
                                        </a>
                                      </div>
                                    )}
                                  </td>
                                )
                              }

                              <td>
                                  <fieldset key={`base-with-${row.id}-${subIndex}`}>
                                    <div className="material">
                                      <input type="text" className="form-input" placeholder=" " value={item.withAON} title={`${item.withAON}%` || "Commission Rate (With AON)"} onChange={(e) => {
                                        const selectedValue = e.target.value;
                                        if (selectedValue === '' ||
                                          ((REGEX_DECIMAL_VALIDATION.test(selectedValue) || REGEX_DECIMAL_VALIDATION_4.test(selectedValue)) && parseFloat(selectedValue) <= 100)) {
                                          const updated = [...configRows];
                                          updated[index].baseIssueRows[subIndex].withAON = selectedValue;
                                          setConfigRows(updated);
                                        }
                                      }}
                                      disabled={Number(row.insurance_type_id) === INS_TYPE_CTPL}
                                      />
                                      {configErrors[index]?.baseIssueRows?.[subIndex]?.withAON && (
                                        <div className="error-msg">{configErrors[index].baseIssueRows[subIndex].withAON}</div>
                                      )}
                                    </div>
                                  </fieldset>
                              </td>

                              <td className="p-relative">
                                  <fieldset className="postion-rel" key={`base-without-${row.id}-${subIndex}`}>
                                    <div className="material">
                                      <input type="text" className="form-input" placeholder=" " value={item.withoutAON} title={`${item.withoutAON}%`|| "Commission Rate (Without AON)"} onChange={(e) => {
                                        const selectedValue = e.target.value;
                                        if (selectedValue === '' ||
                                          ((REGEX_DECIMAL_VALIDATION.test(selectedValue) || REGEX_DECIMAL_VALIDATION_4.test(selectedValue)) && parseFloat(selectedValue) <= 100)) {
                                          const updated = [...configRows];
                                          updated[index].baseIssueRows[subIndex].withoutAON = selectedValue;
                                          setConfigRows(updated);
                                        }
                                      }}/>
                                      {configErrors[index]?.baseIssueRows?.[subIndex]?.withoutAON && (
                                        <div className="error-msg">{configErrors[index].baseIssueRows[subIndex].withoutAON}</div>
                                      )}
                                    </div>
                                    {/* && !(index === 0 && subIndex === 0) */}
                                    {subIndex === row.baseIssueRows.length - 1 && (
                                      <ul className="action-btn delete-row-icon">
                                        <li
                                          // onClick={() => {
                                          //   const updated = [...configRows];
                                          //   if (updated[index].baseIssueRows.length === 1) {
                                          //     console.log("parent remove");
                                          //     const removedTypes = updated[index].selectedTypes;
                                          //     const removedEngineCapacity = updated[index].selectedEngineCapacity;
                                          //     updated.splice(index, 1);
                                          //     setUsedVehicleType(prev =>
                                          //       prev.filter(value => !removedTypes.includes(value))
                                          //     );
                                          //     setUsedEngineCapacity(prev =>
                                          //       prev.filter(value => !removedEngineCapacity.includes(value))
                                          //     );
                                          //   } else {
                                          //     console.log("child remove");
                                          //     updated[index].baseIssueRows.splice(subIndex, 1);
                                          //   }
                                          //   setConfigRows(updated);
                                          // }}
                                          onClick={() => handleDeleteConfigRow(index, subIndex)}
                                        >
                                          <i className="ic-delete-icn"></i>
                                        </li>
                                      </ul>
                                    )}
                                  </fieldset>
                              </td>

                              <td></td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                ))}
              {
                configRows.length > 0 &&
                <div className="btn-save-cancel">
                  <button className="btn-primary" onClick={handleSave}>Save</button>
                  <button className="btn-line" onClick={handleCancel}>cancel</button>
                </div>
              }
            </>
          )
        }
      </div>
    </>
  );
};

export default VehicleUsageConfig;
